<ion-content id="export-popover">
	<ion-buttons class="ion-padding">
		<ion-button (click)="export()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span>{{ 'popover.menu.export' | translate }}</span>
		</ion-button>
		<ion-button (click)="exportLogs()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span>{{ 'popover.menu.exportlogs' | translate }}</span>
		</ion-button>
		<ion-button (click)="goToAbout()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span>{{ 'popover.menu.about' | translate }}</span>
		</ion-button>
		<ion-button (click)="goToSettings()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span>{{ 'popover.menu.settings' | translate }}</span>
		</ion-button>
		<ion-button (click)="transferIn()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span [ngClass]="{ disabled: isNoApiModeEnabled }">{{ 'popover.menu.transferin' | translate }}</span>
		</ion-button>
		<ion-button (click)="goToHelpPage()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<ion-icon class="icon-Help"></ion-icon>
			<span class="help">{{ 'popover.menu.helpPage' | translate }}</span>
		</ion-button>
		<ion-button (click)="goToConnectionsManager()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span [ngClass]="{ disabled: isNoApiModeEnabled }">{{ 'popover.menu.connections' | translate }}</span>
		</ion-button>
		<ion-button (click)="logout()" expand="full" fill="clear" class="ion-no-padding ion-no-margin">
			<span>{{ 'popover.menu.logout.button' | translate }}</span>
		</ion-button>
	</ion-buttons>
</ion-content>
